export default __webpack_public_path__ + "static/media/G0900_2.1719486180000.72df9e82.jpg";